import { TFunction } from 'react-i18next'
import * as yup from 'yup'

export interface AddHookFormFields {
  url?: string
  description?: string
}

export const addHookFormSchema = (t: TFunction<'translation', undefined>) => {
  const url = yup.string().trim().required()
  const description = yup.string().trim().required()

  const formFields = {
    url,
    description,
  }

  return yup.object<Partial<Record<keyof AddHookFormFields, yup.AnySchema>>>(formFields)
}
